<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <logo />
      <!-- <b-col>
        <h2 class="brand-text text-primary ml-1">County Government of</h2>
        <h2 class="brand-text text-primary ml-1">Kericho</h2>
      </b-col> -->
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          You are not authorized! 🔐
        </h2>
        <p class="mb-2">
          You don’t have permission to access this page
        </p>
        <b-button
          variant="primary"
          class="mb-1 btn-sm-block m-1"
          @click.stop="$router.go(-1)"
        >Go Back</b-button>
        <b-button
          variant="primary"
          class="mb-1 btn-sm-block m-1"
          @click.stop="$router.push({ name: 'login' })"
        >Authorize</b-button>
        <b-img
          fluid
          :src="imgUrl"
          alt="Not authorized page"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
// eslint-disable-next-line object-curly-newline
import { BLink, BImg, BButton } from 'bootstrap-vue'
import Logo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'

export default {
  components: {
    BLink,
    BImg,
    BButton,
    Logo,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {},
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
